import { Field, TextInput, SectionCard } from "./_shared";
import ImageUploadField from "./ImageUploadField";

const FAVICON_MIME = ["image/png", "image/svg+xml", "image/x-icon", "image/vnd.microsoft.icon"];
const FAVICON_EXT = /\.(png|svg|ico)$/i;

export default function EditBrand({ value, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <div className="space-y-6">
      <SectionCard title="Identidade da Marca">
        <div className="space-y-5">
          <ImageUploadField
            label="Logo (1080x1080 recomendado, formato quadrado)"
            value={value.logo}
            onChange={(v) => set("logo", v)}
            testId="brand-logo"
          />
          <Field label="Nome da marca / personal">
            <TextInput value={value.name} onChange={(v) => set("name", v)} testId="brand-name-input" />
          </Field>
          <Field label="Slogan / tagline">
            <TextInput value={value.tagline} onChange={(v) => set("tagline", v)} testId="brand-tagline-input" />
          </Field>
        </div>
      </SectionCard>

      <SectionCard title="Favicon (Ícone da Aba do Navegador)">
        <p className="text-sm text-onyx/60 mb-4">
          O favicon é o pequeno ícone que aparece na aba do navegador, ao lado do título da página, e também ao favoritar o site. Recomenda-se formato quadrado de 32x32, 64x64 ou 512x512 pixels.
        </p>
        <ImageUploadField
          label="Favicon (apenas .png, .svg ou .ico)"
          value={value.favicon}
          onChange={(v) => set("favicon", v)}
          testId="brand-favicon"
          acceptTypes={FAVICON_MIME}
          acceptExtRegex={FAVICON_EXT}
          acceptLabel="PNG, SVG ou ICO"
        />
        <p className="text-xs text-onyx/40 mt-3">
          Dica: SVG é a opção mais versátil e leve. PNG quadrado também funciona bem. ICO é o formato tradicional dos favicons.
        </p>
      </SectionCard>
    </div>
  );
}
